import { BaseEntityDto } from '../BaseEntityDto/BaseEntityDto';
import { EntityFieldInfo, EntityFieldInfos } from '../EntityInfo/EntityInfo/EntityInfo';
import { AnyCommonSynchronizationEnvironmentTypesConstraint } from '../types/CommonSynchronizationEnvironmentTypes';
export class BaseEntityInfoUtils {
  private constructor() {}
  public static createFieldInfos<TCommonSynchronizationEnvironmentTypes extends AnyCommonSynchronizationEnvironmentTypesConstraint, TDto extends BaseEntityDto, TEntity extends TDto>(dtoFieldInfos: EntityFieldInfos<TCommonSynchronizationEnvironmentTypes, TDto>, additionalFieldInfos: AdditionalFieldInfos<TCommonSynchronizationEnvironmentTypes, TDto, TEntity>): EntityFieldInfos<TCommonSynchronizationEnvironmentTypes, TEntity> {
    return {
      ...dtoFieldInfos,
      ...additionalFieldInfos
    } as any; // typescript doesn't seem to be be able to handle our typing :(
  }
  public static createBaseFieldInfos<TCommonSynchronizationEnvironmentTypes extends AnyCommonSynchronizationEnvironmentTypesConstraint>(): BaseEntityFieldInfos<TCommonSynchronizationEnvironmentTypes> {
    return {
      revision: {
        name: 'revision',
        defaultValue: 0
      },
      deleted: {
        name: 'deleted',
        defaultValue: false
      },
      originalIds: {
        name: 'originalIds',
        defaultValue: () => []
      },
      deletedAt: {
        name: 'deletedAt',
        defaultValue: null
      }
    };
  }
}
export type BaseEntityFieldInfos<TCommonSynchronizationEnvironmentTypes extends AnyCommonSynchronizationEnvironmentTypesConstraint> = {
  revision: EntityFieldInfo<TCommonSynchronizationEnvironmentTypes, BaseEntityDto, 'revision'>;
  deleted: EntityFieldInfo<TCommonSynchronizationEnvironmentTypes, BaseEntityDto, 'deleted'>;
  deletedAt: EntityFieldInfo<TCommonSynchronizationEnvironmentTypes, BaseEntityDto, 'deletedAt'>;
  originalIds: EntityFieldInfo<TCommonSynchronizationEnvironmentTypes, BaseEntityDto, 'originalIds'>;
};
export type BaseEntity = {
  id: string;
  revision: number | null;
  deleted: boolean;
  deletedAt: string | null;
  originalIds: Array<string>;
};
export type AdditionalFieldInfos<TCommonSynchronizationEnvironmentTypes extends AnyCommonSynchronizationEnvironmentTypesConstraint, TDto extends BaseEntityDto, TEntity extends TDto> = { [key in Exclude<keyof TEntity, keyof TDto | 'id'>]: EntityFieldInfo<TCommonSynchronizationEnvironmentTypes, TEntity, Exclude<key, 'id'>> };